import React from 'react';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function ContactPage() {
  return <div className="pt-20 min-h-screen bg-gray-50" data-id="element-408">
      <div className="bg-navy-900 text-white py-16" data-id="element-409">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-410">
          <h1 className="text-4xl font-serif font-bold mb-4" data-id="element-411">Contact Us</h1>
          <p className="text-xl text-gray-300" data-id="element-412">We'd love to hear from you.</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 -mt-8 pb-20" data-id="element-413">
        <div className="bg-white rounded-xl shadow-xl overflow-hidden grid grid-cols-1 lg:grid-cols-2" data-id="element-414">
          {/* Form */}
          <div className="p-8 md:p-12" data-id="element-415">
            <h2 className="text-2xl font-bold text-navy-900 mb-6" data-id="element-416">
              Send us a message
            </h2>
            <iframe title="Contact form" src="https://form.jotform.com/261658116470559" className="w-full min-h-[600px] border-0" scrolling="no" data-id="element-417" />
          </div>

          {/* Info */}
          <div className="bg-navy-50 p-8 md:p-12 flex flex-col justify-between" data-id="element-418">
            <div data-id="element-419">
              <h2 className="text-2xl font-bold text-navy-900 mb-6" data-id="element-420">
                Contact Information
              </h2>
              <ul className="space-y-6" data-id="element-421">
                <li className="flex items-start space-x-4" data-id="element-422">
                  <MapPin className="h-6 w-6 text-gold-500 mt-1" data-id="element-423" />
                  <div data-id="element-424">
                    <span className="block font-bold text-navy-900" data-id="element-425">
                      Office
                    </span>
                    <span className="text-gray-600" data-id="element-426">
                      357 7th Ave, 2nd Floor
                      <br data-id="element-427" />
                      New York, NY 10001, United States
                    </span>
                  </div>
                </li>
                <li className="flex items-start space-x-4" data-id="element-428">
                  <Phone className="h-6 w-6 text-gold-500 mt-1" data-id="element-429" />
                  <div data-id="element-430">
                    <span className="block font-bold text-navy-900" data-id="element-431">Phone</span>
                    <span className="text-gray-600" data-id="element-432">+1 (678) 807-3391</span>
                  </div>
                </li>
                <li className="flex items-start space-x-4" data-id="element-433">
                  <Mail className="h-6 w-6 text-gold-500 mt-1" data-id="element-434" />
                  <div data-id="element-435">
                    <span className="block font-bold text-navy-900" data-id="element-436">Email</span>
                    <span className="text-gray-600" data-id="element-437">
                      contact@talentbridge.blog
                    </span>
                  </div>
                </li>
                <li className="flex items-start space-x-4" data-id="element-438">
                  <Clock className="h-6 w-6 text-gold-500 mt-1" data-id="element-439" />
                  <div data-id="element-440">
                    <span className="block font-bold text-navy-900" data-id="element-441">Hours</span>
                    <span className="text-gray-600" data-id="element-442">
                      Mon-Fri: 9am - 6pm EST
                    </span>
                  </div>
                </li>
              </ul>
            </div>

            <div className="mt-12 p-6 bg-white rounded-lg shadow-sm" data-id="element-443">
              <h3 className="font-bold text-navy-900 mb-2" data-id="element-444">
                Ready to talk now?
              </h3>
              <p className="text-gray-600 mb-4 text-sm" data-id="element-445">
                Schedule a free 15-minute consultation directly on our calendar.
              </p>
              <Button variant="outline" fullWidth href="mailto:contact@talentbridge.blog" data-id="element-446">
                Book Consultation
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>;
}